import { logRoutes } from "../../constants/Routes";
const axios = require("axios");

export const generateAdLog = (
	viewerId,
	eventType,
	referrerUrl,
	deliveryId,
	credNo,
	adLinkId
) => {
	try {
		axios
			.post(logRoutes.createAdLog, {
				user_id: viewerId,
				type: eventType,
				referrer_url: referrerUrl,
				delivery_id: deliveryId,
				certificate_no: credNo,
				ad_link_id: adLinkId,
			})
			.then((res) => {
				if (res.data.success) {
					console.log("log created successfully");
				}
			});
	} catch (err) {
		console.log(err);
	}
};
